import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { updatePageCriteria } from 'app/store/project/page-criteria/page-criteria.actions';
import {
  Compilers,
  FilterChangedEvent,
  Formatters,
  SearchBarFields,
} from 'shared/modules/controls/search-bar/search-bar';
import { FilterSource } from 'shared/modules/table/table-utils/table-directives';

@Component({
  selector: 'app-notices-filter',
  templateUrl: './notices-filter.component.html',
  styleUrls: ['./notices-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoticesFilterComponent extends FilterSource {
  private _key = '';
  private _form = new UntypedFormGroup({
    triggerId: new UntypedFormControl(),
    createdAt: new UntypedFormControl(),
    recipient: new UntypedFormControl(),
  });

  // readonly noticeTriggers$ = this.store$.select(notices);

  readonly fields: SearchBarFields = {
    triggerId: {
      label: 'HISTORY.RECONCILIATION.triggers',
      translateLabel: true,
      compiler: Compilers.array('trigger.id'),
      formatter: Formatters.invisible(),
    },
    createdAt: {
      label: 'ORDERS.FILTERS.created',
      translateLabel: true,
      compiler: Compilers.dates('createdAt'),
      formatter: Formatters.dates(this.translateService),
    },
    recipient: {
      label: 'TABLE.recipient',
      translateLabel: true,
      compiler: Compilers.specificText('recipient', '"contact"', t => `"${t}"`),
      formatter: Formatters.justValue(),
    },
  };

  get key(): string {
    return this._key;
  }

  @Input()
  set key(value: string) {
    this._key = value;
  }

  get form(): UntypedFormGroup {
    return this._form;
  }

  constructor(private store$: Store, private translateService: TranslateService) {
    super();
  }

  emitFilter(event: FilterChangedEvent): void {
    this.filterChanged.emit(event.filter);

    this.store$.dispatch(updatePageCriteria({
      update: { id: this.key, changes: { formValue: this.form.value, pageIndex: 0 } },
    }));
  }
}
